export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
  viewCount: number;
  commentCount: number;
  isHot: boolean;
  isFeatured: boolean;
  readTime: number;
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "深度调查：某知名企业背后的灰色产业链，涉及金额超十亿",
    excerpt: "经过三个月的卧底调查，我们揭露了一条涉及多家知名企业的庞大灰色产业链。从原材料采购到终端销售，每一个环节都暗藏玄机，内幕令人震惊。",
    content: `<p>经过长达三个月的卧底调查，黑料社区记者团队深入产业链各个环节，揭开了这条涉及多家知名企业的庞大灰色产业链的面纱。</p>
<h2>调查起因</h2>
<p>今年初，一封匿名举报信引起了我们注意。信中详细描述了某行业龙头企业通过一系列复杂的关联交易，将大量资金转移到境外账户的操作手法。</p>
<p>我们随即组建了一支由资深调查记者组成的专项团队，开始了为期三个月的深入调查。</p>
<h2>惊人发现</h2>
<p>调查发现，这条灰色产业链涉及至少五家上市公司和十余家关联企业。通过层层嵌套的股权结构、复杂的跨境贸易单据、以及大量空壳公司的运作，形成了一个难以追踪的资金流动网络。</p>
<p>初步估算，仅过去两年，通过这一网络转移的资金就超过十亿元人民币。</p>
<h2>操作手法揭秘</h2>
<p>经深入调查，该产业链的主要操作手法包括：虚增采购成本、虚假出口贸易、通过境外关联方进行利润转移等。每一个环节都设计得极为精巧，普通审计难以发现端倪。</p>
<h2>后续影响</h2>
<p>该调查报道发布后，立即引发了监管机构的高度关注。目前已有多个部门表示将对此展开专项核查。业内专家指出，这一案例很可能只是冰山一角。</p>
<p>我们将持续关注事件进展，为读者带来最新报道。</p>`,
    categorySlug: "deep-dive",
    coverImage: "https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20building%20at%20night%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20financial%20district%2C%20cinematic%20photography%2C%20deep%20shadows%2C%20professional%20photojournalism%20style%2C%20moody%20tone%2C%20clean%20background&width=1200&height=675&seq=article-1-cover&orientation=landscape",
    author: "深度调查组",
    publishDate: "2026-08-05",
    tags: ["灰色产业链", "企业调查", "资金转移", "上市公司"],
    viewCount: 128500,
    commentCount: 3421,
    isHot: true,
    isFeatured: true,
    readTime: 12,
  },
  {
    id: "article-2",
    title: "独家爆料：某当红明星涉嫌偷税漏税，税务机关已介入调查",
    excerpt: "据知情人士透露，某位常年霸占热搜的当红明星近日被税务机关约谈，涉嫌通过工作室和关联公司进行大规模偷税漏税行为，涉案金额可能高达数千万元。",
    content: `<p>据多位知情人士向黑料社区独家透露，娱乐圈内一位常年霸占热搜榜的当红明星，近日已被税务机关正式约谈。</p>
<h2>事件始末</h2>
<p>消息人士称，该明星通过其名下多家工作室和关联企业，采用"阴阳合同"、虚报成本等多种方式，涉嫌在近三年内偷逃税款数千万元。</p>
<p>税务机关在年初的一次例行抽查中发现了可疑账目，随后展开了深入调查。</p>
<h2>行业内幕</h2>
<p>实际上，类似的税务操作在娱乐圈并不罕见。多位业内人士表示，"阴阳合同"和通过工作室避税几乎是行业公开的秘密。然而，随着近年来税务监管的日益严格，这种灰色地带正在被迅速压缩。</p>
<h2>可能后果</h2>
<p>根据相关法律法规，如果偷税漏税行为被查实，该明星将面临补缴税款、加收滞纳金以及高额罚款。严重情况下，甚至可能面临刑事处罚。</p>
<p>截至发稿时，该明星团队尚未对此事作出公开回应。</p>`,
    categorySlug: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Luxury%20red%20carpet%20event%20with%20dramatic%20spotlight%2C%20celebrity%20silhouette%2C%20paparazzi%20flash%20photography%2C%20glamorous%20yet%20mysterious%20atmosphere%2C%20entertainment%20industry%20scene%2C%20high%20contrast%20lighting%2C%20editorial%20style&width=1200&height=675&seq=article-2-cover&orientation=landscape",
    author: "娱乐调查部",
    publishDate: "2026-08-06",
    tags: ["明星偷税", "娱乐圈", "税务调查", "独家爆料"],
    viewCount: 256800,
    commentCount: 8921,
    isHot: true,
    isFeatured: true,
    readTime: 8,
  },
  {
    id: "article-3",
    title: "某地政府工程招标暗箱操作曝光：指定品牌、围标串标成常态",
    excerpt: "本社区获得了一份内部文件，详细记录了某地一项价值数亿元的政府工程在招标过程中存在的暗箱操作行为。指定品牌参数、预先内定中标方等手段层出不穷。",
    content: `<p>黑料社区近日获得了一份来自内部举报人提供的文件资料，详细揭示了某地一项重大政府工程招标过程中存在的严重违规行为。</p>
<h2>招标内幕</h2>
<p>根据文件记录，该项目在招标文件的编制阶段，就已被精心设计为只有特定企业才能满足条件。技术参数被精确地"量身定制"为某一品牌的产品规格，变相排除了其他潜在竞争者。</p>
<h2>围标串标</h2>
<p>更令人触目惊心的是，文件显示至少有五家企业参与了有组织的围标串标行为。这些企业通过事先商量好的报价策略，确保内定的中标方以"最优价格"中标。</p>
<h2>监管漏洞</h2>
<p>业内专家指出，尽管我国在政府采购和工程招标方面已有较为完善的法律法规体系，但在实际执行层面仍存在诸多漏洞。特别是在参数设定和评标环节，人为操作空间较大。</p>
<h2>最新进展</h2>
<p>据悉，该文件已被转交给相关纪检监察部门。我们将持续关注后续调查进展。</p>`,
    categorySlug: "society",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20government%20building%20architecture%20with%20dramatic%20clouds%2C%20serious%20atmosphere%2C%20Chinese%20official%20building%2C%20documentary%20photography%20style%2C%20clean%20composition%2C%20professional%20journalism&width=1200&height=675&seq=article-3-cover&orientation=landscape",
    author: "社会观察组",
    publishDate: "2026-08-04",
    tags: ["政府工程", "招标暗箱", "围标串标", "反腐"],
    viewCount: 98700,
    commentCount: 2156,
    isHot: true,
    isFeatured: true,
    readTime: 10,
  },
  {
    id: "article-4",
    title: "巨头科技公司内部文件泄露：AI大模型训练数据存在严重隐私隐患",
    excerpt: "一份从某头部科技公司内部流出的技术文档显示，该公司在训练其旗舰AI大模型时，使用了大量未经用户授权采集的个人数据，隐私安全问题触目惊心。",
    content: `<p>黑料社区独家获取了一份来自某头部科技公司的内部技术文档，该文档揭示了该公司在AI大模型训练过程中存在的严重隐私安全隐患。</p>
<h2>文档内容</h2>
<p>这份标注为"内部机密"的技术文档详细记录了大模型的训练数据来源。令人震惊的是，其中包含了大量从公开互联网上爬取的个人信息，包括但不限于社交媒体发言、论坛帖子、甚至部分私密对话记录。</p>
<h2>隐私风险</h2>
<p>安全专家分析指出，这些数据中包含的个人信息可能在模型输出时被间接泄露。更严重的是，这些数据一旦被恶意利用，可能对用户隐私造成不可挽回的损害。</p>
<h2>监管态度</h2>
<p>近年来，全球多国监管机构对AI数据隐私问题高度关注。业内人士认为，这一事件可能触发新一轮的行业整顿。</p>
<h2>公司回应</h2>
<p>截至目前，涉事公司尚未对文件泄露事件及内容真实性作出正面回应。其公关部门仅表示"正在内部调查中"。</p>`,
    categorySlug: "tech",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20server%20room%20with%20glowing%20data%20cables%2C%20AI%20technology%20concept%2C%20dark%20atmosphere%20with%20blue%20and%20green%20LED%20lights%2C%20cyberpunk%20aesthetic%2C%20technology%20infrastructure%2C%20dramatic%20lighting&width=1200&height=675&seq=article-4-cover&orientation=landscape",
    author: "科技调查组",
    publishDate: "2026-08-07",
    tags: ["AI大模型", "隐私泄露", "科技巨头", "数据安全"],
    viewCount: 185300,
    commentCount: 5678,
    isHot: true,
    isFeatured: false,
    readTime: 9,
  },
  {
    id: "article-5",
    title: "房地产市场最新动向：多地出现断供潮，银行坏账压力骤增",
    excerpt: "据多方消息源证实，全国多个二三线城市近期出现了大量房贷断供现象。部分楼盘断供比例已超过30%，银行系统面临前所未有的坏账压力。",
    content: `<p>近期，黑料社区记者走访了全国多个二三线城市，发现房地产市场的断供现象正在加速蔓延。</p>
<h2>断供潮来袭</h2>
<p>在华中某省会城市，一个曾经炙手可热的楼盘如今冷冷清清。据业主群内部统计，该楼盘近三个月的房贷断供率已超过35%。业主们纷纷表示，月供压力太大，加上房价持续下跌，继续还贷的意愿大幅降低。</p>
<h2>银行承压</h2>
<p>断供潮给银行系统带来了巨大压力。业内人士透露，部分地方性银行的房贷不良率已从去年底的1.5%飙升至当前的4%以上。如果这一趋势持续，可能引发系统性的金融风险。</p>
<h2>政策走向</h2>
<p>分析人士认为，监管部门可能会出台一系列措施来应对这一局面，包括降低存量房贷利率、延长还款期限等。但这些措施能否有效遏制断供潮，仍需时间验证。</p>`,
    categorySlug: "finance",
    coverImage: "https://readdy.ai/api/search-image?query=Empty%20residential%20apartment%20buildings%20in%20Chinese%20city%2C%20overcast%20sky%2C%20real%20estate%20crisis%20mood%2C%20documentary%20photography%2C%20urban%20landscape%2C%20serious%20atmosphere%2C%20clean%20composition&width=1200&height=675&seq=article-5-cover&orientation=landscape",
    author: "财经观察组",
    publishDate: "2026-08-03",
    tags: ["房地产", "断供潮", "银行坏账", "经济"],
    viewCount: 156200,
    commentCount: 4321,
    isHot: true,
    isFeatured: false,
    readTime: 11,
  },
  {
    id: "article-6",
    title: "某知名餐饮连锁品牌后厨卫生触目惊心，监管部门突击检查",
    excerpt: "记者暗访发现，一家在全国拥有超过500家门店的知名餐饮连锁品牌，其后厨卫生状况令人作呕。食材过期、蟑螂横行、员工无健康证等问题触目惊心。",
    content: `<p>食品安全一直是公众关注的焦点。近日，黑料社区记者对一家全国知名餐饮连锁品牌进行了为期两周的暗访调查，发现其后厨卫生状况极其恶劣。</p>
<h2>暗访发现</h2>
<p>记者以打工者身份应聘入职后，亲眼目睹了后厨的惊人一幕：过期食材被反复使用、操作台上蟑螂横行、员工直接用手指试菜、洗碗池同时用于清洗拖把……</p>
<h2>监管介入</h2>
<p>报道发布后，当地市场监管部门迅速组织了突击检查。初步检查结果显示，该门店存在多项严重违规行为，已被责令停业整顿。</p>
<h2>品牌回应</h2>
<p>涉事品牌总部发布声明称，对旗下门店的卫生问题深表歉意，将进行全面自查整改。然而，多位消费者表示对该品牌的信任已经严重受损。</p>
<p>我们将持续关注整改落实情况。</p>`,
    categorySlug: "hot-tracking",
    coverImage: "https://readdy.ai/api/search-image?query=Dirty%20commercial%20kitchen%20interior%20with%20poor%20hygiene%2C%20dark%20and%20messy%20atmosphere%2C%20food%20safety%20investigation%20theme%2C%20documentary%20style%20photography%2C%20grimy%20surfaces%2C%20dramatic%20shadows&width=1200&height=675&seq=article-6-cover&orientation=landscape",
    author: "消费维权组",
    publishDate: "2026-08-06",
    tags: ["食品安全", "餐饮卫生", "暗访调查", "消费维权"],
    viewCount: 312400,
    commentCount: 12567,
    isHot: true,
    isFeatured: true,
    readTime: 8,
  },
  {
    id: "article-7",
    title: "教育界大地震：某知名高校招生办主任涉嫌受贿千万被带走",
    excerpt: "最新消息，某985高校招生办公室主任因涉嫌在招生环节收受巨额贿赂被纪检部门带走调查。据传涉及金额超过千万，多名校领导亦被牵连。",
    content: `<p>教育公平是社会公平的底线。然而，近日一则消息在教育界引发轩然大波。</p>
<h2>事件经过</h2>
<p>据权威消息源证实，某知名985高校招生办公室主任于本周二被纪检部门从办公室直接带走。知情人士透露，该主任涉嫌在近五年的招生工作中，通过"特殊通道"安排考生入学，并从中收受巨额贿赂。</p>
<h2>招生黑幕</h2>
<p>业内人士指出，高校招生环节的腐败并非个例。自主招生、特长生录取、研究生推免等环节都曾曝出过权钱交易。然而，此次涉案金额之大、涉及面之广，仍令人震惊。</p>
<h2>社会反响</h2>
<p>此事在社交媒体上引发了广泛讨论。许多家长和学生表达了对教育公平的深切担忧。舆论普遍呼吁加强对高校招生环节的监督和透明化管理。</p>`,
    categorySlug: "hot-tracking",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20university%20campus%20entrance%20with%20grand%20gate%2C%20formal%20academic%20atmosphere%2C%20overcast%20sky%2C%20serious%20mood%2C%20documentary%20photography%2C%20clean%20composition&width=1200&height=675&seq=article-7-cover&orientation=landscape",
    author: "教育观察组",
    publishDate: "2026-08-07",
    tags: ["高校招生", "教育腐败", "受贿", "985高校"],
    viewCount: 221000,
    commentCount: 7823,
    isHot: true,
    isFeatured: false,
    readTime: 9,
  },
  {
    id: "article-8",
    title: "数字货币交易所又出事：用户资产一夜清零，平台声称'技术故障'",
    excerpt: "某二线数字货币交易平台昨日突发系统故障，大量用户反映账户资产归零。平台官方回应称是技术故障正在修复，但多位用户质疑这是跑路前兆。",
    content: `<p>数字货币交易市场的风险再次被推向风口浪尖。昨日晚间，一家拥有数十万用户的数字货币交易平台突发"系统故障"，大量用户账户资产显示为零。</p>
<h2>事件回顾</h2>
<p>8月6日晚间约21时，该平台用户陆续发现自己的账户余额归零，所有交易记录消失。恐慌情绪迅速在社交媒体上蔓延。</p>
<p>约两小时后，平台发布公告称是"数据库技术故障"，正在紧急修复中。然而，这一解释并未平息用户的焦虑。</p>
<h2>跑路疑云</h2>
<p>多位业内人士分析指出，所谓"技术故障"很可能只是借口。该平台近期被曝出存在严重的资金链问题，用户提现申请大量积压。此次"故障"极有可能是有预谋的跑路行为。</p>
<h2>监管困境</h2>
<p>数字货币交易平台目前处于监管的灰色地带，用户的资产安全缺乏有效保障。一旦平台出现问题，用户维权将面临极大困难。</p>`,
    categorySlug: "finance",
    coverImage: "https://readdy.ai/api/search-image?query=Digital%20cryptocurrency%20trading%20screen%20with%20red%20declining%20charts%2C%20dark%20room%20atmosphere%2C%20financial%20crisis%20mood%2C%20computer%20monitor%20glow%2C%20dramatic%20lighting%2C%20technology%20and%20finance%20theme&width=1200&height=675&seq=article-8-cover&orientation=landscape",
    author: "财经调查组",
    publishDate: "2026-08-07",
    tags: ["数字货币", "交易所", "跑路", "金融安全"],
    viewCount: 178900,
    commentCount: 6890,
    isHot: false,
    isFeatured: false,
    readTime: 7,
  },
  {
    id: "article-9",
    title: "深度揭秘：刷单产业如何操控你的购物决策",
    excerpt: "你在电商平台看到的「爆款」，很可能只是刷单制造出来的假象。本报道深入揭秘了一条完整的刷单产业链，从组织架构到操作手法，一网打尽。",
    content: `<p>当你打开电商App，看到一款商品销量破万、好评如潮，你会毫不犹豫地下单吗？</p>
<p>如果是，你可能已经落入了精心设计的"刷单陷阱"。</p>
<h2>刷单产业链全貌</h2>
<p>黑料社区记者通过长达两个月的卧底调查，揭秘了一条完整的刷单产业链。这条产业链由上至下分为几个层级：刷单平台运营方、任务发布者（商家）、刷单团队负责人、以及底层刷手。</p>
<h2>操作手法</h2>
<p>商家通过刷单平台发布任务，刷手按照要求进行"浏览-加购-下单-好评"的全流程操作。为了躲避平台风控，刷手们还会模拟真实用户的搜索行为，甚至先浏览竞品再回到目标商品下单。</p>
<h2>为何屡禁不止</h2>
<p>尽管各大电商平台都在严厉打击刷单行为，但这条灰色产业链依然蓬勃发展。核心原因在于：刷单能为商家带来实实在在的销量和排名提升，而刷单平台也能从中获取可观的佣金收入。</p>`,
    categorySlug: "deep-dive",
    coverImage: "https://readdy.ai/api/search-image?query=E-commerce%20warehouse%20with%20packages%20and%20computers%2C%20organized%20chaos%2C%20product%20review%20manipulation%20theme%2C%20documentary%20photography%2C%20clean%20composition%2C%20professional%20investigation%20style&width=1200&height=675&seq=article-9-cover&orientation=landscape",
    author: "深度调查组",
    publishDate: "2026-08-02",
    tags: ["刷单产业", "电商平台", "消费陷阱", "深度调查"],
    viewCount: 143200,
    commentCount: 3456,
    isHot: false,
    isFeatured: false,
    readTime: 14,
  },
  {
    id: "article-10",
    title: "某短视频平台主播涉嫌诈骗粉丝数百万，受害者遍布全国",
    excerpt: "一位拥有百万粉丝的短视频平台主播，涉嫌通过虚假投资理财项目诈骗粉丝，涉案金额已经超过500万元。目前已有超过200名受害者联合报案。",
    content: `<p>短视频平台的崛起催生了大量网红主播，然而也滋生了新型的诈骗手段。</p>
<h2>诈骗模式</h2>
<p>据受害者描述，这位主播通过在直播中展示奢华生活方式建立信任后，开始向粉丝推荐所谓"高收益低风险"的投资理财项目。实际上，这些项目根本不存在，所有投资款都被主播据为己有。</p>
<h2>受害者群像</h2>
<p>受害者来自全国各地，以中老年群体和全职妈妈为主。他们大多缺乏投资理财知识，被主播的"真诚"和"专业"所迷惑。有人被骗光了毕生积蓄，有人甚至因此家庭破裂。</p>
<h2>法律分析</h2>
<p>律师指出，该主播的行为已经涉嫌构成诈骗罪。鉴于涉案金额特别巨大、受害人数众多，一旦定罪将面临十年以上有期徒刑。</p>
<p>警方已对此立案侦查，我们将持续跟进。</p>`,
    categorySlug: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20live%20streaming%20app%20interface%2C%20dark%20room%2C%20dramatic%20lighting%2C%20social%20media%20theme%2C%20documentary%20style%2C%20modern%20technology%20and%20crime%20concept&width=1200&height=675&seq=article-10-cover&orientation=landscape",
    author: "消费维权组",
    publishDate: "2026-08-01",
    tags: ["主播诈骗", "短视频", "粉丝经济", "维权"],
    viewCount: 196500,
    commentCount: 5678,
    isHot: false,
    isFeatured: false,
    readTime: 9,
  },
  {
    id: "article-11",
    title: "保健品行业乱象调查：天价'神药'背后的营销骗局",
    excerpt: "一瓶成本不足十元的普通维生素，经过包装摇身一变成了售价上千元的「抗癌神药」。记者深入调查保健品会销行业，揭露了针对老年人的精准营销骗局。",
    content: `<p>"阿姨，您这个气血不足很严重啊，不调理的话后果不堪设想！"在一间酒店会议室里，身穿白大褂的"专家"正在给一群老年人"义诊"。</p>
<h2>会销模式揭秘</h2>
<p>这就是保健品行业最常见的"会销"模式：通过免费体检、赠送小礼品等方式吸引老年人到场，然后由所谓的"专家"进行恐吓式诊断，最后推销高价"特效保健品"。</p>
<h2>利润惊人</h2>
<p>记者调查发现，一瓶售价高达1280元的"细胞再生精华液"，实际生产成本不足10元。营销链条上的各环节层层分润，最终消费者买单的是高昂的营销费用。</p>
<h2>维权困境</h2>
<p>由于老年消费者普遍缺乏维权意识，加上销售人员往往在交易完成后迅速"失联"，受害者维权难度极大。多地消协均表示，保健品投诉是近年来投诉量增长最快的领域之一。</p>`,
    categorySlug: "society",
    coverImage: "https://readdy.ai/api/search-image?query=Health%20supplement%20bottles%20on%20display%2C%20pharmacy%20shelf%2C%20dramatic%20lighting%2C%20consumer%20protection%20theme%2C%20documentary%20photography%2C%20clean%20composition%2C%20investigative%20journalism%20style&width=1200&height=675&seq=article-11-cover&orientation=landscape",
    author: "社会观察组",
    publishDate: "2026-07-30",
    tags: ["保健品", "会销骗局", "老年人", "消费维权"],
    viewCount: 112800,
    commentCount: 2890,
    isHot: false,
    isFeatured: false,
    readTime: 10,
  },
  {
    id: "article-12",
    title: "独家：某手机厂商被曝在系统中植入后门，可远程获取用户数据",
    excerpt: "安全研究人员发现，某国产手机品牌在其定制系统中预置了一个隐藏后门程序，可以在用户不知情的情况下，远程获取包括位置、通讯录、短信在内的敏感数据。",
    content: `<p>手机安全再次敲响警钟。近日，一位独立安全研究人员向黑料社区爆料，在某国产手机品牌的定制系统中发现了一个隐藏极深的后门程序。</p>
<h2>技术分析</h2>
<p>据研究人员介绍，该后门程序伪装成一个系统更新服务，拥有极高的系统权限。它可以在用户完全不知情的情况下，收集并上传地理位置、通讯录、短信内容、通话记录等大量敏感数据。</p>
<h2>厂商回应</h2>
<p>该手机厂商回应称，该程序是"用于改善用户体验的数据分析模块"，否认存在恶意行为。然而，多位安全专家对此解释表示质疑，认为其数据收集范围和权限要求远超正常分析所需。</p>
<h2>用户应对</h2>
<p>安全专家建议，用户应密切关注手机的系统权限管理，定期检查应用的行为记录。如有异常，应及时备份数据并考虑恢复出厂设置。</p>`,
    categorySlug: "tech",
    coverImage: "https://readdy.ai/api/search-image?query=Smartphone%20with%20hacker%20code%20on%20screen%2C%20dark%20atmosphere%2C%20cybersecurity%20theme%2C%20red%20warning%20glow%2C%20technology%20threat%20concept%2C%20dramatic%20lighting%2C%20digital%20privacy&width=1200&height=675&seq=article-12-cover&orientation=landscape",
    author: "科技调查组",
    publishDate: "2026-07-28",
    tags: ["手机安全", "隐私后门", "数据泄露", "国产手机"],
    viewCount: 167400,
    commentCount: 4390,
    isHot: false,
    isFeatured: false,
    readTime: 8,
  },
];